import { render, staticRenderFns } from "./bank-login.vue?vue&type=template&id=3a05c8da&scoped=true&"
import script from "./bank-login.vue?vue&type=script&lang=js&"
export * from "./bank-login.vue?vue&type=script&lang=js&"
import style0 from "./bank-login.vue?vue&type=style&index=0&id=3a05c8da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a05c8da",
  null
  
)

export default component.exports